import type { FC } from 'react';
import { useAsync } from '@wix/cli-ui-kit';
import { getRepoType, createPackageManager } from '@wix/package-manager';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { useProjectModel } from '../../model.js';

export const ServeCommandDeprecated: FC = () => {
  const { model } = useProjectModel();

  useAsync(async () => {
    let packageManagerRunCmd;

    try {
      const repoType = await getRepoType(model.projectFolder);
      const packageManager = await createPackageManager(repoType);
      packageManagerRunCmd = packageManager.getRunCmd();
    } catch {
      // in case we fail to determine package manager, we just ignore it
    }

    throw new CliError({
      code: CliErrorCode.ServeDeprecated({ packageManagerRunCmd }),
      cause: undefined,
    });
  }, []);

  return null;
};
